// src/shared/hooks/useResellerBrand.ts

import { useAuth } from '@/features/auth/hooks/useAuth';
import { ResellerBrand } from '@/shared/utils/resellerBrand';

/**
 * Whether the selected account gets the white-label (themediacdn) experience.
 * Account-based, so it follows the account selector and never the login host.
 */
export function useResellerBrand(): boolean {
  const { selectedCustomer } = useAuth();
  return ResellerBrand.isReseller(selectedCustomer?.cfg.reseller);
}
